import { privacyPolicyContent } from '@/config/marketing-content/legal-pages'
import { LegalDocumentLayout } from '@/components/marketing/legal-document-layout'

export function PrivacyPolicyPage() {
  return <LegalDocumentLayout document={privacyPolicyContent} />
}
